import { createLazyComponent, LazyAction, LazyImport, LazyModule } from 'owa-bundling';

export { CLPSubjectHeaderLabelProps } from './components/CLPSubjectHeaderLabel';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "CLP", webpackPrefetch: true */ './lazyIndex')
);

export const lazyLoadCLPUserLabels = new LazyAction(lazyModule, m => m.loadCLPUserLabels);
export const lazyShowJustificationModal = new LazyImport(lazyModule, m => m.showJustificationModal);
export const lazyLoadItemCLPInfo = new LazyAction(lazyModule, m => m.loadItemCLPInfo);
export const lazyUpdateItemCLPInfo = new LazyImport(lazyModule, m => m.updateItemCLPInfo);
export const lazyLogReadCLPLabel = new LazyImport(lazyModule, m => m.logReadCLPLabel);
export const lazyTriggerCLPAutoLabeling = new LazyImport(lazyModule, m => m.triggerCLPAutoLabeling);
export const CLPSubjectHeaderLabel = createLazyComponent(lazyModule, m => m.CLPSubjectHeaderLabel);
